// Utility wrappers around the Clarity queue so other files can reuse them.

export function ensureClarityQueue() {
    if (!window.clarity) {
        window.clarity = function() { (window.clarity.q = window.clarity.q || []).push(arguments); };
        console.log('clarity queue initialized');
    }
}

/**
 * Set user-level properties in Clarity.
 * surveyId / responderId are added as separate props and a combined clarityUser object.
 */
export function setClarityUser(surveyId, responderId) {
    try {
        ensureClarityQueue();
        if (surveyId) window.clarity('set', 'surveyId', surveyId);
        if (responderId) window.clarity('set', 'userId', responderId);
        if (surveyId || responderId) window.clarity('set', 'clarityUser', { surveyId, responderId });
   console.log('clarity user set','surveyid', surveyId ,'userId' ,responderId);
   
    } catch (e) {
        // keep silent in production; useful while debugging
        // eslint-disable-next-line no-console
        console.warn('Clarity set user error', e);
    }
}

export function setClarityResponder(surveyId, responderId) {
    try {
        ensureClarityQueue();
        if (surveyId) window.clarity('set', 'surveyId', surveyId);
        if (responderId) window.clarity('set', 'responderId', responderId);
        if (surveyId || responderId) window.clarity('set', 'clarityUser', { surveyId, responderId });
   console.log('clarity responder set','surveyid', surveyId ,'responderId' ,responderId);
   
    } catch (e) {
        // keep silent in production; useful while debugging
        // eslint-disable-next-line no-console
        console.warn('Clarity set user error', e);
    }
}

export function setClarityHost(host) {
    try {
        ensureClarityQueue();

        // Accept either uid string/number or a user object
        const hostId = host && (host.uid || host.id) ? (host.uid || host.id) : (typeof host === 'string' || typeof host === 'number' ? host : null);
        const hostObj = host && typeof host === 'object' ? {
            id: hostId,
            email: host.email || null,
            name: host.displayName || host.name || null
        } : null;

        if (hostId) window.clarity('set', 'hostId', hostId);
        if (hostObj) window.clarity('set', 'clarityHost', hostObj);

        console.log('clarity host set', hostId, hostObj);
    } catch (e) {
        console.warn('Clarity set host error', e);
    }
}

/**
 * Send a named event to Clarity. If the Clarity script isn't loaded yet
 * events are queued using the built-in queue function.
 */
export function sendClarityEvent(eventName, payload = {}) {
    try {
        ensureClarityQueue();
        window.clarity('event', eventName, payload);
        console.log('clarity event set');
        
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Clarity event error', e);
    }
}